import { render } from "./App.vue?vue&type=template&id=606f85ee&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=606f85ee&lang=scss"

import exportComponent from "/Users/fahridarmawan/Documents/Project Web/pmb-online/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__